import { render } from "./StoresModule.vue?vue&type=template&id=47ae5e8c&scoped=true"
import script from "./StoresModule.vue?vue&type=script&lang=js"
export * from "./StoresModule.vue?vue&type=script&lang=js"

import "./StoresModule.vue?vue&type=style&index=0&id=47ae5e8c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47ae5e8c"

export default script